// extracted by mini-css-extract-plugin
export default {"homeContainer":"Folder_homeContainer__CUmY2","contentContainer":"Folder_contentContainer__FRnct"};